import React, { Component } from 'react';
import axios from '../../axios'
import {beforeRouterEach} from '../../common/index'
import TableGroup from '../../base/table/index'
import Title from '../../base/title/index'
import ButtonGroup from '../../base/buttonGroup/index'
import AddModal from './addModal/index'
import ModifyModal from './modifyModal/index'
import './index.css'
import { Divider, message,Modal } from 'antd';
const { confirm } = Modal;

class Index extends Component {
    constructor(props,context){
        super(props,context);
        this.state={
            btnGroup: [
                {
                    type:'add',
                    text:'新增管理员'
                },
                {
                    type:'setPermission',
                    text:'管理权限设置'
                },
            ],
            titleMsg: {
                titleName: '管理员管理',
            },
            table: {
                hasHeight: true,
                isPageShow: true,
                current: 1,
                totalCount: 0,
                columns: [
                    {
                        title:'管理员账号',
                        dataIndex:'userName',
                    },
                    {
                        title: '权限',
                        dataIndex: 'menuName',
                    },   
                    {
                        title: '操作',
                        key: 'action',
                        render: (text, record) => (
                            <span>
                                <span>
                                    <span className='tableBtn' onClick={(event) => {
                                            this.reset(record)
                                            event.stopPropagation()
                                        }}>重置密码</span><Divider type="vertical"/>
                                   <span className='tableBtn' onClick={(event) => {
                                            this.modify(record)
                                            event.stopPropagation()
                                        }}>管理员设置</span><Divider type="vertical"/>
                                    <span className='tableBtn' onClick={(event) => {
                                            this.del(record)
                                            event.stopPropagation()
                                        }}>删除</span>
                                    
                                   
                                </span>
                        </span>
                        ),
                    }
                ],
                data: [],
                isSelection: false
            },
            tableParams:{
                rows:10,
                page:1,
            },
            addModalVisible:false,
            modifyModalVisible:false,
            permissionArr:[
              
            ],
            detailData:{
                
            },
            resetData:{

            },
        }
    }
    whickBtnClicked(val){
        if(val==='add'){
            this.setState({
                addModalVisible:true
            })
        }else if(val==='setPermission'){
            this.props.history.push('/index/setPermission');
        }
    } 
    reset(record){
        axios.gets('/api/v1/user/detail',{id:record.id})
            .then((res)=>{
                if(res.status===200){
                    this.setState({
                        resetData:res.data
                    },()=>{
                        let _this=this;
                        confirm({
                            title: '是否重置当前账号密码?',
                            content: '',
                            onOk() {
                                let data={
                                    id:_this.state.resetData.id,
                                    passWord:_this.state.resetData.passWord,
                                    newPassWord:'123456'
                                }
                                axios.posts('/api/v1/user/update/pass',data)
                                    .then((res)=>{
                                        if(res.status===200){
                                            message.success('重置成功！')
                                        }else{
                                            message.error(res.message)
                                        }
                                    })
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        });
                    })
                }else{
                    message.error(res.message)
                }
            })
        
    }
    modify(record){
        axios.gets('/api/v1/user/detail',{id:record.id})
            .then((res)=>{
                if(res.status===200){
                    res.data.menu=parseInt(res.data.menu)
                    this.setState({
                        detailData:res.data
                    },()=>{
                        this.setState({
                            modifyModalVisible:true
                        })
                    })
                }else{
                    message.error(res.message)
                }
            })
        
    }
    del(record){
        let _this=this;
        confirm({
            title: '是否删除当前管理员?',
            content: '',
            onOk() {
              axios.posts('/api/v1/user/remove',{id:record.id})
                .then((res)=>{
                    if(res.status===200){
                        message.success('删除成功！')
                        _this.getDataList()
                    }else{
                        message.error(res.message)
                    }
                })
            },
            onCancel() {
              console.log('Cancel');
            },
        });
    }
    getDataList(){
        axios.gets('/api/v1/user/menu/find',{page:1,rows:100})
            .then((res)=>{
                if(res.status===200){
                    let data=[]
                    res.data.map((item,index)=>{
                        data.push({
                            value:item.id,
                            label:item.name
                        })
                        return item
                    })
                    this.setState({
                        permissionArr:data
                    },()=>{
                        axios.gets('/api/v1/user/find',this.state.tableParams)
                            .then((res)=>{
                                if(res.status===200){
                                    
                                    let data = Object.assign({}, this.state.table, {
                                        data: res.data,
                                        totalCount: res.total,
                                    });
                                    data.data.map((item,index)=>{
                                        this.state.permissionArr.map((items,indexs)=>{
                                            if(parseInt(item.menu)===items.value){
                                                item.menuName=items.label
                                            }
                                            return items
                                        })
                                        return item
                                    })
                                    this.setState({
                                        table: data
                                    })
                                }else{
                                    message.error(res.message)
                                }
                            })
                    })
                }else{
                    message.error(res.message)
                }
            })
        
        
    }
   
    selectedChange(val){
        console.log(val)
    }
    tableSizeChange(current, pageSize) {
        let data = Object.assign({}, this.state.table, {
            current: current,
        });
        this.setState({
            table: data
        });
        let data2 = Object.assign({}, this.state.tableParams, {
            rows: pageSize,
        });
        this.setState({
            tableParams: data2
        }, () => {
            this.getDataList();
        });

    }
    tablePageChange(page) {
        let data = Object.assign({}, this.state.table, {
            current: page,
        });
        this.setState({
            table: data
        });
        let data2 = Object.assign({}, this.state.tableParams, {
            page: page ,
        });
        this.setState({
            tableParams: data2
        }, () => {
            this.getDataList();
        });
    }
   
    componentDidMount(){
        beforeRouterEach(this)
        this.getDataList();
    }
    changeAddModal(val,values){
        this.setState({
            addModalVisible:val
        })
        if(values!==''){
            let data={
                userName:values.accountName,
                menu:values.permissionArray.toString(),
                passWord:'123456'
            }
            axios.posts('/api/v1/user/insert',data)
                .then((res)=>{
                    if(res.status===200){
                        message.success('新增成功！')
                        this.getDataList();
                    }else{
                        message.error(res.message)
                    }
                })
        }
    }
    changeModifyModal(val,values){
        this.setState({
            modifyModalVisible:val
        })
        if(values==='submit'){
            let data={
                id:this.state.detailData.id,
                menu:this.state.detailData.menu.toString()
            }
            axios.posts('/api/v1/user/modify',data)
                .then((res)=>{
                    if(res.status===200){
                        message.success('修改成功！')
                        this.getDataList();
                    }else{
                        message.error(res.message)
                    }
                })
        }
    }
    changePermissionArr(val){
        let data = Object.assign({}, this.state.detailData, {
            menu: val
        });
        this.setState({
            detailData: data
        })
    }
    

    render() {
        return (
            <div className="superadminManage">
                <Title titleMsg={this.state.titleMsg}/> 
               <ButtonGroup
                    whichClick={this.whickBtnClicked.bind(this)}
                    btnGroup={this.state.btnGroup}
               />
               <TableGroup
                    selectedChange={this.selectedChange.bind(this)}
                    pageChange={this.tablePageChange.bind(this)}
                    sizeChange={this.tableSizeChange.bind(this)}
                    table={this.state.table}/>
                <AddModal
                    permissionArr={this.state.permissionArr}
                    changeVisible={this.changeAddModal.bind(this)}
                    visible={this.state.addModalVisible}
                />
                <ModifyModal
                    detailData={this.state.detailData}
                    permissionArr={this.state.permissionArr}
                    changeVisible={this.changeModifyModal.bind(this)}
                    visible={this.state.modifyModalVisible}
                    changePermissionArr={this.changePermissionArr.bind(this)}
                />
            </div>
        );
    }
}

export default Index;